(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      document.querySelectorAll('[data-rotate]').forEach(function(rot){
        if(rot.dataset.rotInit) return; rot.dataset.rotInit = '1';
        var items = rot.querySelectorAll('.t-announce__item');
        if(items.length < 2) return;
        var i = 0;
        setInterval(function(){
          items[i].hidden = true;
          i = (i+1) % items.length;
          items[i].hidden = false;
        }, 4200);
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      document.querySelectorAll('.t-atelier__steps').forEach(function(steps){
        if(steps.dataset.atelierInit) return; steps.dataset.atelierInit = '1';
        steps.querySelectorAll('.t-atelier__step').forEach(function(step){
          step.addEventListener('click', function(){
            steps.querySelectorAll('.t-atelier__step').forEach(function(s){ s.classList.remove('is-open'); });
            step.classList.add('is-open');
          });
        });
      });
      // testimonial rotator (crossfade)
      document.querySelectorAll('[data-atelier-quotes]').forEach(function(box){
        if(box.dataset.rotInit) return; box.dataset.rotInit = '1';
        var qs = box.querySelectorAll('.t-atelier__quote');
        if(qs.length < 2) return;
        var i = 0;
        setInterval(function(){
          qs[i].classList.remove('is-active');
          i = (i + 1) % qs.length;
          qs[i].classList.add('is-active');
        }, 4500);
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      document.querySelectorAll('[data-bundle-add]').forEach(function(btn){
        if(btn.dataset.bundleInit) return; btn.dataset.bundleInit = '1';
        btn.addEventListener('click', function(){
          var ids = (btn.getAttribute('data-bundle-add')||'').split(',').filter(Boolean);
          if(!ids.length) return;
          var items = ids.map(function(id){ return { id: parseInt(id,10), quantity: 1 }; });
          var route = (window.THAYA && window.THAYA.routes && window.THAYA.routes.cart_add) || '/cart/add.js';
          var label = btn.textContent; btn.disabled = true;
          fetch(route, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items: items }) })
            .then(function(r){ return r.json(); })
            .then(function(){ btn.disabled = false; if(window.ThayaCart){ window.ThayaCart.refresh().then(window.ThayaCart.open); } })
            .catch(function(){ btn.disabled = false; });
        });
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-rows"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      document.querySelectorAll('.t-catrow').forEach(function(row){
        if(row.dataset.railInit) return; row.dataset.railInit = '1';
        var rail = row.querySelector('[data-rail]');
        var prev = row.querySelector('[data-rail-prev]');
        var next = row.querySelector('[data-rail-next]');
        if(!rail) return;
        var rtl = (document.documentElement.dir === 'rtl') || getComputedStyle(rail).direction === 'rtl';
        function step(){
          var card = rail.querySelector('.t-card');
          var w = card ? card.getBoundingClientRect().width + 16 : 280;
          return Math.round(w * 1.5);
        }
        if(prev) prev.addEventListener('click', function(){ rail.scrollBy({ left: (rtl ? 1 : -1) * step(), behavior:'smooth' }); });
        if(next) next.addEventListener('click', function(){ rail.scrollBy({ left: (rtl ? -1 : 1) * step(), behavior:'smooth' }); });
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function init(){
      document.querySelectorAll('.t-tabsec').forEach(function(sec){
        if(sec.dataset.tabInit) return; sec.dataset.tabInit = '1';
        var tabs   = [].slice.call(sec.querySelectorAll('.t-tabs__btn'));
        var panels = [].slice.call(sec.querySelectorAll('.t-tabpanel'));
        var prev   = sec.querySelector('[data-tab-prev]');
        var next   = sec.querySelector('[data-tab-next]');
        var curEl  = sec.querySelector('[data-count-cur]');
        var totEl  = sec.querySelector('[data-count-total]');
        var rtl    = document.documentElement.dir === 'rtl';
        var tabsWrap = sec.querySelector('.t-tabs');
        var ink    = sec.querySelector('[data-tab-ink]');

        function positionInk(){
          var a = sec.querySelector('.t-tabs__btn.is-active');
          if(!a || !ink) return;
          ink.style.width = a.offsetWidth + 'px';
          ink.style.transform = 'translateX(' + a.offsetLeft + 'px)';
        }
        function centerActive(){
          var a = sec.querySelector('.t-tabs__btn.is-active');
          if(!a || !tabsWrap) return;
          var target = a.offsetLeft - (tabsWrap.clientWidth - a.offsetWidth) / 2;
          tabsWrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        }

        function activePanel(){ return sec.querySelector('.t-tabpanel.is-active'); }
        function railInfo(rail){
          var card = rail.querySelector('.t-card');
          if(!card) return { pages:1, cur:1, step:300 };
          var cw   = card.getBoundingClientRect().width + 16;
          var per  = Math.max(1, Math.round(rail.clientWidth / cw));
          var total= rail.querySelectorAll('.t-card').length;
          var pages= Math.max(1, Math.ceil(total / per));
          var cur  = Math.min(pages, Math.round(Math.abs(rail.scrollLeft) / (per * cw)) + 1);
          return { pages:pages, cur:cur, step: per * cw };
        }
        function update(){
          var p = activePanel(); if(!p) return;
          var rail = p.querySelector('[data-rail]'); if(!rail) return;
          var info = railInfo(rail);
          if(curEl) curEl.textContent = pad(info.cur);
          if(totEl) totEl.textContent = pad(info.pages);
          if(prev)  prev.disabled = info.cur <= 1;
          if(next)  next.disabled = info.cur >= info.pages;
        }
        function selectTab(i){
          tabs.forEach(function(t){ t.classList.toggle('is-active', +t.dataset.tab === i); });
          panels.forEach(function(p){ p.classList.toggle('is-active', +p.dataset.panel === i); });
          positionInk();
          centerActive();
          update();
        }
        tabs.forEach(function(t){ t.addEventListener('click', function(){ selectTab(+t.dataset.tab); }); });
        panels.forEach(function(p){
          var r = p.querySelector('[data-rail]');
          if(r) r.addEventListener('scroll', function(){ if(p.classList.contains('is-active')) update(); }, { passive:true });
        });
        function go(dir){
          var p = activePanel(); if(!p) return;
          var rail = p.querySelector('[data-rail]'); if(!rail) return;
          var info = railInfo(rail);
          rail.scrollBy({ left: dir * info.step * (rtl ? -1 : 1), behavior:'smooth' });
        }
        if(prev) prev.addEventListener('click', function(){ go(-1); });
        if(next) next.addEventListener('click', function(){ go(1); });
        if(!activePanel() && panels[0]) selectTab(+panels[0].dataset.panel);
        else update();
        positionInk();
        window.addEventListener('resize', function(){ update(); positionInk(); });
        window.addEventListener('load', positionInk);
        setTimeout(positionInk, 250);
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fbt"]) return;
  try {
    
  (function(){
    function money(cents){
      var fmt = (window.THAYA && window.THAYA.money_format) || 'Dhs. {{amount}}';
      var v = (cents/100).toFixed(2).replace(/\.00$/, '');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v).replace(/<[^>]+>/g, '');
    }
    function initFbt(sec){
      if(!sec || sec.dataset.fbtReady) return; sec.dataset.fbtReady = '1';
      var checks = [].slice.call(sec.querySelectorAll('.t-fbt__check'));
      var totalEl = sec.querySelector('[data-fbt-total]');
      var addBtn = sec.querySelector('[data-fbt-add]');
      function recalc(){
        var sum = 0, n = 0;
        checks.forEach(function(c){ if(c.checked){ sum += parseInt(c.dataset.price,10) || 0; n++; } });
        if(totalEl) totalEl.textContent = money(sum);
        if(addBtn){ addBtn.disabled = n === 0; }
      }
      checks.forEach(function(c){ c.addEventListener('change', recalc); });
      if(addBtn){
        addBtn.addEventListener('click', function(){
          var items = checks.filter(function(c){ return c.checked; }).map(function(c){ return { id: parseInt(c.dataset.variant,10), quantity: 1 }; });
          if(!items.length) return;
          var route = (window.THAYA && window.THAYA.routes && window.THAYA.routes.cart_add) || '/cart/add.js';
          addBtn.disabled = true;
          fetch(route, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items: items }) })
            .then(function(r){ return r.json(); })
            .then(function(){ addBtn.disabled = false; if(window.ThayaCart){ window.ThayaCart.refresh().then(window.ThayaCart.open); } })
            .catch(function(){ addBtn.disabled = false; });
        });
      }
      recalc();
    }
    window.__fbtInit = initFbt;
    function boot(){ document.querySelectorAll('.t-fbt').forEach(initFbt); }
    if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      document.querySelectorAll('[data-trust-rotator]').forEach(function(rot){
        if(rot.dataset.rotInit) return; rot.dataset.rotInit = '1';
        var slides = rot.querySelectorAll('.t-trust__slide');
        if(slides.length < 2) return;
        var mq = window.matchMedia('(max-width:600px)');
        var i = 0, timer = null;
        function go(){
          slides[i].classList.remove('is-active');
          i = (i + 1) % slides.length;
          slides[i].classList.add('is-active');
        }
        function start(){ if(!mq.matches) return; if(!timer) timer = setInterval(go, 3200); }
        function stop(){ if(timer){ clearInterval(timer); timer = null; } }
        function reset0(){ slides.forEach(function(s, idx){ s.classList.toggle('is-active', idx === 0); }); i = 0; }
        function apply(){ if(mq.matches){ start(); } else { stop(); reset0(); } }
        apply();
        (mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply));
        rot.addEventListener('mouseenter', stop);
        rot.addEventListener('mouseleave', start);
        document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : start(); });
      });
      // one-time reveal for the desktop static row
      document.querySelectorAll('.t-trust[data-trust]').forEach(function(bar){
        if(bar.dataset.revInit) return; bar.dataset.revInit = '1';
        function reveal(){ bar.setAttribute('data-in',''); }
        if(!('IntersectionObserver' in window)){ reveal(); return; }
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if(e.isIntersecting){ reveal(); io.disconnect(); } });
        }, { threshold:.15 });
        io.observe(bar);
        setTimeout(reveal, 1500);
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();
})();
